import React, { useMemo } from "react";
import { Stack } from "@mui/material";

import { useGetAllMaterialData } from "../../hooks";
import { HubTableTemplate } from "../../components";
import { FOUNDRIES } from "../../constants";
import {
  CreateMaterialDialog,
  DeleteMaterialDialog,
} from "../../dialogs";

import MaterialsContextMenu from "./MaterialsContextMenu";

const sortable = true;

const baseItems = [
  { id: "name", label: "Name", sortable },
  { id: "weight", label: "Weight", sortable },
  { id: "category", label: "Category" },
];

const baseKeys = [
  { value: "name" },
  { value: "weight" },
  { value: "category", isChip: true },
];

// Build dynamic per-location price columns from FOUNDRIES so the table grows
// automatically if a foundry is added or renamed.
const buildLocationColumns = () => {
  const items = FOUNDRIES.map((loc) => ({
    id: `price_${loc.id}`,
    label: `${loc.label} Price`,
  }));

  const keys = FOUNDRIES.map((loc) => ({
    value: `pricesByLocation.${loc.id}`,
    isCurrency: true,
    defaultValue: 0,
  }));

  return { items, keys };
};

export const MaterialsTable = () => {
  const { data, isLoading } = useGetAllMaterialData();

  const { items, keys } = useMemo(() => {
    const loc = buildLocationColumns();
    return {
      items: [...baseItems, ...loc.items],
      keys: [...baseKeys, ...loc.keys],
    };
  }, []);

  const prefix = "material";
  const meta = {
    ...(data?.meta ? data?.meta : {}),
    prefix,
  };

  const headerProps = { items, prefix, includeEnd: true };
  const bodyProps = {
    items: data?.rows,
    keys,
    ContextMenu: MaterialsContextMenu,
  };
  const props = { headerProps, bodyProps, meta, isLoading };

  return (
    <Stack gap="10px" overflow="hidden">
      <HubTableTemplate id="MaterialsTable" {...props} />
      <CreateMaterialDialog />
      <DeleteMaterialDialog />
    </Stack>
  );
};

export default MaterialsTable;
